<template>
  <div>
    <header class="pt10">
      <DateChange ref="dateChange" @change="handlerDateChange">
        <template #title>
          <van-cell @click="storeSelectVisible = true">
            <van-field
              autocomplete="off"
              v-model="params.storeName"
              name="storeName"
              inputmode="none"
              placeholder="请选择仓库"
              readonly
            />
          </van-cell>
        </template>
      </DateChange>
      <StoreSelect
        :visible="storeSelectVisible"
        @confirm="storeSelectConfirm"
      ></StoreSelect>
    </header>

    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="已显示全部"
      ref="scrollContainer"
      @load="getList(true)"
    >
      <div v-for="item in tableData" :key="item.id" class="container">
        <!-- 头部：基本信息 -->
        <div class="header">
          <div class="header-left">
            <div class="code">单据号: {{ item.code }}</div>
            <div class="code">仓库: {{ item.scName }}</div>
            <div class="code">创建时间: {{ item.createTime }}</div>
            <div class="code">任务备注: {{ item.description }}</div>
          </div>
          <div class="header-right">
            <div class="tit">
              {{ getTextByValue(TAKE_STOCK_PLAN_TYPE, item.takeType) }}
            </div>
            <van-tag
              :type="getTakeStatusType(item.takeStatus)"
              plain
              size="small"
            >
              {{ getTakeStatusDesc(item.takeStatus) }}
            </van-tag>
            <van-button size="mini" type="primary" @click="goInventory(item)">
              去盘点
            </van-button>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import DateChange from "../../../components/dateChange.vue";
import StoreSelect from "../../../components/storeSelect.vue";
import {
  cancel,
  selector,
  remove,
} from "../../../service/api/stock/take/plan/index";
import { getTextByValue } from "../../../utils/constants";
import {
  TAKE_STOCK_PLAN_STATUS,
  TAKE_STOCK_PLAN_TYPE,
} from "../../../utils/constants";

export default {
  name: "InventoryTask",
  components: {
    DateChange,
    StoreSelect,
  },
  data() {
    return {
      name: "关联盘点任务",
      TAKE_STOCK_PLAN_TYPE,
      getTextByValue,
      params: {
        scId: null,
        storeName: "",
        createTimeStart: "",
        createTimeEnd: "",
        taking: true,
        pageIndex: 1,
        pageSize: 20,
        available: true,
      },
      storeSelectVisible: false,
      loading: false,
      finished: false,
      id: null,
      columns: [
        {
          key: "code",
          title: "单据号",
        },
        {
          key: "scCode",
          title: "仓库编号",
        },
        {
          key: "scName",
          title: "仓库名称",
        },
        {
          key: "takeType",
          title: "盘点类别",
          formatter: (cellValue) => {
            return getTextByValue(TAKE_STOCK_PLAN_TYPE, cellValue);
          },
        },
        {
          key: "bizName",
          title: "盘点内容",
        },
        {
          key: "takeStatus",
          title: "盘点状态",
          formatter: (cellValue) => {
            return getTextByValue(TAKE_STOCK_PLAN_STATUS, cellValue);
          },
        },
        {
          key: "createTime",
          title: "创建时间",
        },
        {
          key: "createBy",
          title: "创建人",
        },
        {
          key: "updateTime",
          title: "操作时间",
        },
        {
          key: "updateBy",
          title: "操作人",
        },
        {
          key: "description",
          title: "备注",
        },
      ],
      tableData: [],
      totalCount: 0,
      pageIndex: 1,
      pageSize: 20,
      totalPage: 1,
    };
  },
  mounted() {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const key = localStorage.key(i);
      if (key && key.startsWith("inventory_")) {
        localStorage.removeItem(key);
      }
    }

    this.params.createTimeStart = this.$refs.dateChange.formattedStartDate
      ? this.$refs.dateChange.formattedStartDate + " 00:00:00"
      : `${new Date().toJSON().slice(0, 10)} 00:00:00`;
    this.params.createTimeEnd = this.$refs.dateChange.formattedEndDate
      ? this.$refs.dateChange.formattedEndDate + " 23:59:59"
      : `${new Date().toJSON().slice(0, 10)} 23:59:59`;

    this.onSubmit();
  },
  methods: {
    getTakeStatusType(status) {
      const typeMap = {
        0: "primary",
        6: "warning",
        9: "success",
        12: "danger",
      };
      return typeMap[status] || "default";
    },

    getTakeStatusDesc(status) {
      return getTextByValue(TAKE_STOCK_PLAN_STATUS, status);
    },

    getTypeTag(type) {
      const typeMap = {
        0: "primary",
        1: "success",
        2: "warning",
        3: "danger",
      };
      return typeMap[type] || "default";
    },
    canShowCreateDiff(row) {
      return row.takeStatus === 0;
    },
    canShowHandleDiff(row) {
      return row.takeStatus === 6;
    },
    canShowCancel(row) {
      return row.takeStatus === 0 || row.takeStatus === 6;
    },
    canShowDelete(row) {
      return row.takeStatus === 12;
    },
    search() {
      this.onSubmit();
    },
    handlerDateChange(start, end) {
      this.params.createTimeStart = start ? `${start} 00:00:00` : start;
      this.params.createTimeEnd = end ? `${end} 23:59:59` : end;
      this.onSubmit();
    },
    storeSelectConfirm(row) {
      this.params.scId = row.id;
      this.params.storeName = row.name;
      this.storeSelectVisible = false;
      this.onSubmit();
    },
    onSubmit() {
      this.pageIndex = 1;
      this.finished = false;
      this.tableData = [];
      this.loading = false;
      this.getList();
    },
    getList(load) {
      if (load) {
        this.pageIndex++;
      }
      this.loading = true;
      const params = {
        ...this.params,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      selector(params)
        .then((res) => {
          this.loading = false;
          console.log(res, "关联盘点任务");
          if (res.code === 200) {
            const list = res.data.datas || res.data.list || [];
            this.totalCount = res.data.totalCount || res.data.total || 0;
            this.totalPage = Math.ceil(this.totalCount / this.pageSize);
            if (this.pageIndex === 1) {
              this.tableData = list;
            } else {
              this.tableData = [...this.tableData, ...list];
            }
            this.finished =
              this.pageIndex >= this.totalPage || list.length === 0;
          } else {
            this.finished = true;
          }
        })
        .catch(() => {
          this.loading = false;
          this.finished = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    createDiff(row) {
      this.id = row.id;
      this.$nextTick(() => this.$refs.diffDialog.openDialog());
    },
    handleDiff(row) {
      this.id = row.id;
      this.$nextTick(() => this.$refs.handleDialog.openDialog());
    },
    cancelRow(row) {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确定要作废该盘点任务吗？",
        })
        .then(() => {
          cancel({ id: row.id }).then((res) => {
            if (res.code === 200) {
              this.onSubmit();
            }
          });
        })
        .catch(() => {});
    },
    deleteRow(row) {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确定要删除该盘点任务吗？",
        })
        .then(() => {
          remove({ id: row.id }).then((res) => {
            if (res.code === 200) {
              this.onSubmit();
            }
          });
        })
        .catch(() => {});
    }, 
     rowClick(item) {},
    goInventory(row) {
      this.params.scId = row.scId;
      this.params.storeName = row.scName;
      this.$router.push({
        path: "/stock/inventory/goods",
        query: {
          planId: row.id,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
* {
  touch-action: pan-y;
}

.van-cell {
  padding: 5px 2px 2px 5px !important;
}

.container {
  padding: 10px 15px;
  border-radius: 4px;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-bottom: 8px;
    border-bottom: 1px solid #eee;
  }

  .header-left {
    flex: 2;
    .code {
      font-size: 14px;
      color: #333;
    }
  }

  .header-right {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;

    .tit {
      color: #000;
    }

    .store-name {
      text-align: right;
      font-size: 14px;
      color: #666;
      font-weight: 500;
    }
  }
}

.actions {
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

::v-deep .van-list {
  height: calc(100vh - 7rem);
  overflow: auto;
}
</style>
